"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusStyles = exports.hoverStyles = exports.baseStyles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Constant = require("../Constant");

var _primary, _secondary, _primary2, _secondary2, _primary3, _secondary3;

var baseStyles = _styledTheming.default.variants('mode', 'variant', {
  primary: (_primary = {}, (0, _defineProperty2.default)(_primary, _Constant.Themes.HOMEBRIDGE, {
    backgroundColor: _Constant.Color.HOMEBRIDGE_BLUE,
    border: "1px solid ".concat(_Constant.Color.HOMEBRIDGE_BLUE),
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_primary, _Constant.Themes.HOMEPOINT, {
    backgroundColor: _Constant.Color.HOMEPOINT_NAVY,
    border: "1px solid ".concat(_Constant.Color.HOMEPOINT_NAVY),
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_primary, _Constant.Themes.SYNERGY_ONE, {
    backgroundColor: _Constant.Color.BLACK,
    border: "1px solid ".concat(_Constant.Color.BLACK),
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_primary, _Constant.Themes.CALIBER, {
    backgroundColor: _Constant.Color.CALIBER_BLUE_NEW,
    border: "2px solid ".concat(_Constant.Color.CALIBER_BLUE_NEW),
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_primary, _Constant.Themes.FIGURE, {
    backgroundColor: _Constant.Color.MELLOW_YELLOW,
    border: "2px solid ".concat(_Constant.Color.MELLOW_YELLOW),
    color: _Constant.Color.DARK_GREY
  }), (0, _defineProperty2.default)(_primary, _Constant.Themes.PETERSENDEAN, {
    backgroundColor: _Constant.Color.MELLOW_YELLOW,
    border: "2px solid ".concat(_Constant.Color.MELLOW_YELLOW),
    color: _Constant.Color.DARK_GREY
  }), (0, _defineProperty2.default)(_primary, _Constant.Themes.PELLA, {
    backgroundColor: _Constant.Color.MELLOW_YELLOW,
    border: "2px solid ".concat(_Constant.Color.MELLOW_YELLOW),
    color: _Constant.Color.DARK_GREY
  }), (0, _defineProperty2.default)(_primary, _Constant.Themes.GUARANTEED_RATE, {
    backgroundColor: _Constant.Color.GUARANTEED_RATE_ARROW_RED,
    border: "2px solid ".concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED),
    color: _Constant.Color.WHITE
  }), _primary),
  secondary: (_secondary = {}, (0, _defineProperty2.default)(_secondary, _Constant.Themes.HOMEBRIDGE, {
    backgroundColor: _Constant.Color.WHITE,
    border: "1px solid ".concat(_Constant.Color.HOMEBRIDGE_YELLOW),
    color: _Constant.Color.BLACK
  }), (0, _defineProperty2.default)(_secondary, _Constant.Themes.HOMEPOINT, {
    backgroundColor: _Constant.Color.WHITE,
    border: "1px solid ".concat(_Constant.Color.HOMEPOINT_NAVY),
    color: _Constant.Color.HOMEPOINT_NAVY
  }), (0, _defineProperty2.default)(_secondary, _Constant.Themes.SYNERGY_ONE, {
    backgroundColor: _Constant.Color.WHITE,
    border: "2px solid ".concat(_Constant.Color.BLACK),
    color: _Constant.Color.BLACK
  }), (0, _defineProperty2.default)(_secondary, _Constant.Themes.CALIBER, {
    backgroundColor: _Constant.Color.WHITE,
    border: "2px solid ".concat(_Constant.Color.CALIBER_GREEN_NEW),
    color: _Constant.Color.DARK_GREY
  }), (0, _defineProperty2.default)(_secondary, _Constant.Themes.FIGURE, {
    backgroundColor: _Constant.Color.WHITE,
    border: "2px solid ".concat(_Constant.Color.MELLOW_YELLOW),
    color: _Constant.Color.DARK_GREY
  }), (0, _defineProperty2.default)(_secondary, _Constant.Themes.PETERSENDEAN, {
    backgroundColor: _Constant.Color.WHITE,
    border: "2px solid ".concat(_Constant.Color.MELLOW_YELLOW),
    color: _Constant.Color.DARK_GREY
  }), (0, _defineProperty2.default)(_secondary, _Constant.Themes.PELLA, {
    backgroundColor: _Constant.Color.WHITE,
    border: "2px solid ".concat(_Constant.Color.MELLOW_YELLOW),
    color: _Constant.Color.DARK_GREY
  }), (0, _defineProperty2.default)(_secondary, _Constant.Themes.GUARANTEED_RATE, {
    backgroundColor: _Constant.Color.WHITE,
    border: "2px solid ".concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED),
    color: _Constant.Color.GUARANTEED_RATE_ARROW_RED
  }), _secondary)
});

exports.baseStyles = baseStyles;

var hoverStyles = _styledTheming.default.variants('mode', 'variant', {
  primary: (_primary2 = {}, (0, _defineProperty2.default)(_primary2, _Constant.Themes.HOMEBRIDGE, {
    backgroundColor: _Constant.Color.HOMEBRIDGE_BLUE_DARK,
    borderColor: _Constant.Color.HOMEBRIDGE_BLUE_DARK,
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_primary2, _Constant.Themes.HOMEPOINT, {
    backgroundColor: _Constant.Color.HOMEPOINT_LIGHT_BLUE,
    borderColor: _Constant.Color.HOMEPOINT_LIGHT_BLUE,
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_primary2, _Constant.Themes.SYNERGY_ONE, {
    backgroundColor: _Constant.Color.SYNERGY_ONE_GRAY_LIGHT,
    border: "1px solid ".concat(_Constant.Color.SYNERGY_ONE_GRAY_LIGHT),
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_primary2, _Constant.Themes.CALIBER, {
    backgroundColor: _Constant.Color.CALIBER_NAVY,
    borderColor: _Constant.Color.CALIBER_NAVY,
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_primary2, _Constant.Themes.FIGURE, {
    backgroundColor: _Constant.Color.PURPLE_RAIN,
    borderColor: _Constant.Color.PURPLE_RAIN,
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_primary2, _Constant.Themes.PETERSENDEAN, {
    backgroundColor: _Constant.Color.PURPLE_RAIN,
    borderColor: _Constant.Color.PURPLE_RAIN,
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_primary2, _Constant.Themes.PELLA, {
    backgroundColor: _Constant.Color.PURPLE_RAIN,
    borderColor: _Constant.Color.PURPLE_RAIN,
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_primary2, _Constant.Themes.GUARANTEED_RATE, {
    backgroundColor: _Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY,
    border: "2px solid ".concat(_Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY),
    color: _Constant.Color.WHITE
  }), _primary2),
  secondary: (_secondary2 = {}, (0, _defineProperty2.default)(_secondary2, _Constant.Themes.HOMEBRIDGE, {
    backgroundColor: _Constant.Color.HOMEBRIDGE_YELLOW,
    borderColor: _Constant.Color.HOMEBRIDGE_YELLOW,
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_secondary2, _Constant.Themes.HOMEPOINT, {
    backgroundColor: _Constant.Color.WHITE,
    borderColor: _Constant.Color.HOMEPOINT_LIGHT_BLUE,
    color: _Constant.Color.HOMEPOINT_LIGHT_BLUE
  }), (0, _defineProperty2.default)(_secondary2, _Constant.Themes.SYNERGY_ONE, {
    backgroundColor: _Constant.Color.SYNERGY_ONE_YELLOW_DARK,
    border: "2px solid ".concat(_Constant.Color.SYNERGY_ONE_YELLOW_DARK),
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_secondary2, _Constant.Themes.CALIBER, {
    backgroundColor: _Constant.Color.CALIBER_FOREST_GREEN,
    borderColor: _Constant.Color.CALIBER_FOREST_GREEN,
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_secondary2, _Constant.Themes.FIGURE, {
    backgroundColor: _Constant.Color.PURPLE_RAIN,
    borderColor: _Constant.Color.PURPLE_RAIN,
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_secondary2, _Constant.Themes.PETERSENDEAN, {
    backgroundColor: _Constant.Color.PURPLE_RAIN,
    borderColor: _Constant.Color.PURPLE_RAIN,
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_secondary2, _Constant.Themes.PELLA, {
    backgroundColor: _Constant.Color.PURPLE_RAIN,
    borderColor: _Constant.Color.PURPLE_RAIN,
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_secondary2, _Constant.Themes.GUARANTEED_RATE, {
    backgroundColor: _Constant.Color.WHITE,
    border: "2px solid ".concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED),
    color: _Constant.Color.GUARANTEED_RATE_ARROW_RED
  }), _secondary2)
});
/* box-shadow is used because the focus outline follows the border-radius curve and is placed outside of the button */


exports.hoverStyles = hoverStyles;

var focusStyles = _styledTheming.default.variants('mode', 'variant', {
  primary: (_primary3 = {}, (0, _defineProperty2.default)(_primary3, _Constant.Themes.HOMEBRIDGE, {
    backgroundColor: _Constant.Color.HOMEBRIDGE_BLUE,
    borderColor: _Constant.Color.BLACK,
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.HOMEBRIDGE_BLUE)
  }), (0, _defineProperty2.default)(_primary3, _Constant.Themes.HOMEPOINT, {
    backgroundColor: _Constant.Color.HOMEPOINT_NAVY,
    borderColor: _Constant.Color.HOMEPOINT_NAVY,
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.HOMEPOINT_LIGHT_BLUE)
  }), (0, _defineProperty2.default)(_primary3, _Constant.Themes.SYNERGY_ONE, {
    backgroundColor: _Constant.Color.BLACK,
    border: "1px solid ".concat(_Constant.Color.BLACK),
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.SYNERGY_ONE_YELLOW_DARK)
  }), (0, _defineProperty2.default)(_primary3, _Constant.Themes.CALIBER, {
    backgroundColor: _Constant.Color.CALIBER_BLUE_NEW,
    borderColor: _Constant.Color.CALIBER_BLUE_NEW,
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.CALIBER_PASTEL_BLUE)
  }), (0, _defineProperty2.default)(_primary3, _Constant.Themes.FIGURE, {
    backgroundColor: _Constant.Color.MELLOW_YELLOW,
    borderColor: _Constant.Color.MELLOW_YELLOW,
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.FOCUS_B)
  }), (0, _defineProperty2.default)(_primary3, _Constant.Themes.PETERSENDEAN, {
    backgroundColor: _Constant.Color.MELLOW_YELLOW,
    borderColor: _Constant.Color.MELLOW_YELLOW,
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.FOCUS_B)
  }), (0, _defineProperty2.default)(_primary3, _Constant.Themes.PELLA, {
    backgroundColor: _Constant.Color.MELLOW_YELLOW,
    borderColor: _Constant.Color.MELLOW_YELLOW,
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.FOCUS_B)
  }), (0, _defineProperty2.default)(_primary3, _Constant.Themes.GUARANTEED_RATE, {
    backgroundColor: _Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY,
    border: "3px solid ".concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED),
    color: _Constant.Color.WHITE
  }), _primary3),
  secondary: (_secondary3 = {}, (0, _defineProperty2.default)(_secondary3, _Constant.Themes.HOMEBRIDGE, {
    backgroundColor: _Constant.Color.HOMEBRIDGE_YELLOW,
    borderColor: _Constant.Color.BLACK,
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.HOMEBRIDGE_YELLOW)
  }), (0, _defineProperty2.default)(_secondary3, _Constant.Themes.HOMEPOINT, {
    backgroundColor: _Constant.Color.WHITE,
    borderColor: _Constant.Color.WHITE,
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.HOMEPOINT_NAVY)
  }), (0, _defineProperty2.default)(_secondary3, _Constant.Themes.SYNERGY_ONE, {
    backgroundColor: _Constant.Color.SYNERGY_ONE_YELLOW_DARK,
    border: "1px solid ".concat(_Constant.Color.SYNERGY_ONE_YELLOW_DARK),
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.BLACK)
  }), (0, _defineProperty2.default)(_secondary3, _Constant.Themes.CALIBER, {
    backgroundColor: _Constant.Color.CALIBER_FOREST_GREEN,
    borderColor: _Constant.Color.CALIBER_FOREST_GREEN,
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.CALIBER_GREEN_NEW),
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_secondary3, _Constant.Themes.FIGURE, {
    backgroundColor: _Constant.Color.PURPLE_RAIN,
    borderColor: _Constant.Color.PURPLE_RAIN,
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.FOCUS),
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_secondary3, _Constant.Themes.PETERSENDEAN, {
    backgroundColor: _Constant.Color.PURPLE_RAIN,
    borderColor: _Constant.Color.PURPLE_RAIN,
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.FOCUS),
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_secondary3, _Constant.Themes.PELLA, {
    backgroundColor: _Constant.Color.PURPLE_RAIN,
    borderColor: _Constant.Color.PURPLE_RAIN,
    boxShadow: "0 0 0 4px ".concat(_Constant.Color.FOCUS),
    color: _Constant.Color.WHITE
  }), (0, _defineProperty2.default)(_secondary3, _Constant.Themes.GUARANTEED_RATE, {
    backgroundColor: _Constant.Color.GUARANTEED_RATE_ARROW_RED,
    border: "3px solid ".concat(_Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY),
    color: _Constant.Color.WHITE
  }), _secondary3)
});

exports.focusStyles = focusStyles;